var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBandeiraEspanha = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9000 6000",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h9000v6000H0",
    fill: "#c60b1e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1500h9000v3000H0",
    fill: "#ffc400"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBandeiraEspanha);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bandeira-espanha.351ea6e05bc721c37deeaba607afae82.svg";